export enum StatusPedido {
  RECEBIDO = 'RECEBIDO',
  EM_PREPARO = 'EM_PREPARO',
  PRONTO = 'PRONTO',
  EM_ROTA = 'EM_ROTA',
  ENTREGUE = 'ENTREGUE',
  CANCELADO = 'CANCELADO'
}

export interface Endereco {
  rua: string;
  numero: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
}

export interface ItemPedido {
  id: string;
  nome: string;
  quantidade: number;
  preco: number;
  observacao?: string;
  comboName?: string;
  comboId?: string;
  comboKey?: string;
}

export interface Pedido {
  id: string;
  idPedido: string;
  cliente: string;
  telefone: string;
  endereco: Endereco;
  itens: ItemPedido[];
  valorItens: number;
  valorBrutoItens: number;
  descontoCombos: number;
  taxaEntrega: number;
  valorTotal: number;
  status: StatusPedido;
  dataCriacao: string;
  dataAtualizacao: string;
  observacao?: string;
  couponCode?: string;
  couponDiscount?: number;
  formaPagamento?: string;
  courierId?: string;
  courierName?: string;
  courierPhone?: string;
  paymentStatus?: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED' | 'EXPIRED';
  paymentMethod?: 'PIX' | 'CREDIT_CARD' | 'DEBIT_CARD' | 'OTHER';
  paymentId?: string;
}

export type StatusColumn = {
  id: StatusPedido;
  title: string;
  color: string;
};
